import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { postUserInfo } from "../../utils/api";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Login = ({ onLogin }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      localStorage.setItem("access_token", tokenResponse.access_token);
      setLoading(true);
      setError(null);
      fetch("https://www.googleapis.com/oauth2/v1/userinfo?alt=json", {
        headers: {
          Authorization: `Bearer ${tokenResponse.access_token}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to get user information");
          }
          return response.json();
        })
        .then(async (user) => {
          localStorage.setItem("user", JSON.stringify(user));
          setUser(user);
          onLogin(user);
          await postUserInfo(user);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Login process failed:", error);
          setError("Authentication failed. Please try again.");
          setLoading(false);
        });
    },
    onError: (error) => {
      console.error("Login Failed:", error);
      setError("Google login failed. Please try again.");
      setLoading(false);
    },
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white rounded-xl shadow-xl overflow-hidden border border-gray-100">
        {/* Header with brand color */}
        <div className="bg-blue-600 py-6">
          <h2 className="text-center text-3xl font-extrabold text-white tracking-tight">
            North Star
          </h2>
          <p className="mt-1 text-center text-sm text-blue-100">
            Your centralized dashboard platform
          </p>
        </div>

        {/* Main content */}
        <div className="p-8">
          <h3 className="text-xl font-medium text-gray-900 text-center mb-6">
            Welcome back
          </h3>

          {error && (
            <div className="mb-6 bg-red-50 border-l-4 border-red-500 p-4 rounded">
              <p className="text-sm text-red-700">{error}</p>
            </div>
          )}

          <button
            onClick={() => login()}
            disabled={loading}
            className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} size="xl" className="mr-2" />
            ) : (
              <span className="flex items-center text-lg">
                <FontAwesomeIcon icon={faGoogle} size="xl" className="mr-2" />
                Sign in with Google
              </span>
            )}
          </button>

          <div className="mt-8">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">
                  Secure authentication
                </span>
              </div>
            </div>
          </div>

          {/* Security features */}
          <div className="mt-6 space-y-3">
            <div className="flex items-center justify-center">
              <span className="h-2 w-2 rounded-full bg-green-500 mr-2"></span>
              <p className="text-sm text-gray-600">Enterprise-grade security</p>
            </div>
            <div className="flex items-center justify-center">
              <span className="h-2 w-2 rounded-full bg-green-500 mr-2"></span>
              <p className="text-sm text-gray-600">
                Single sign-on with Google
              </p>
            </div>
            <div className="flex items-center justify-center">
              <span className="h-2 w-2 rounded-full bg-green-500 mr-2"></span>
              <p className="text-sm text-gray-600">Data protection & privacy</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 py-4 px-8 border-t border-gray-100">
          <p className="text-xs text-center text-gray-500">
            &copy; {new Date().getFullYear()} North Star. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
